/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsUsersMinus: {
  name: 'users-minus';
  data: string;
} = {
  name: 'users-minus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M5 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM1.5 6a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM5 11.5a5.485 5.485 0 0 0-4.1 1.834.5.5 0 0 1-.745-.668A6.485 6.485 0 0 1 5 10.5c1.66 0 3.173.622 4.322 1.645a4 4 0 0 1 6.138 2.784.5.5 0 1 1-.99.142 3 3 0 0 0-4.44-2.187 6.493 6.493 0 0 1 1.1 1.95.5.5 0 0 1-.943.333A5.503 5.503 0 0 0 5 11.5Zm5.5-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm-.5-4a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4Z" fill="currentColor"/></svg>`,
};
